import React from "react";

export default function Event(props) {
  const getRec = props.getEventData;
  return (
    <>
      {getRec ? (
        <>
          <table className="table table-bordered">
            <thead>
              <tr className="header-row changefont">
                <th className="indexname" size="3">
                  Symbol
                </th>
                <th className="ltp" size="3">
                  Purpose
                </th>
                <th className="signal" size="3">
                  Event Date
                </th>
                <th className="signal" size="3">
                  LTP
                </th>
                <th className="signal" size="3">
                  Open
                </th>
                <th className="signal" size="3">
                  High
                </th>
                <th className="signal" size="3">
                  Low
                </th>
                <th className="signal" size="3">
                  Volume
                </th>
              </tr>
            </thead>
            <tbody>
              {getRec.map((item, key) => (
                <tr key={key}>
                  <td>{item.symbol} </td>
                  <td>{item.purpose} </td>
                  <td>{item.evnet_date} </td>
                  <td style={{ color: item?.vcolor }}>{item.l} </td>
                  <td style={{ color: item?.color }}>{item.op}</td>
                  <td>{item.hi} </td>
                  <td>{item.lo} </td>
                  <td>{item.vo} </td>
                </tr>
              ))}
            </tbody>
          </table>
        </>
      ) : (
        ""
      )}
    </>
  );
}
